import React, { useState } from "react";
import { Link } from "react-router-dom";
import SiteLayout from "@/components/site/SiteLayout";
import Seo, { breadcrumbLd, faqLd, ogUrl } from "@/components/site/Seo";
import RiskCard from "@/components/site/RiskCard";
import { ProgressBar, RelatedStrip } from "@/components/site/conversion";
import { RISKS } from "@/data/risks";
import { useContent } from "@/lib/useContent";
import { API } from "@/lib/api";
import { track } from "@/lib/analytics";

function ScamBand() {
  const [f, setF] = useState({ name: "", email: "", whatsapp: "" });
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!f.name || !f.email) return;
    try {
      await fetch(`${API}/guides/download`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ guide_slug: "scam-checklist", ...f }) });
      track("guide_download", { slug: "scam-checklist" }); setDone(true);
    } catch {}
  };
  return (
    <div className="reqband" style={{ margin: "10px 0", gridTemplateColumns: "1fr 1fr" }} data-testid="scam-band">
      <div className="reqcopy">
        <div className="k2" style={{ textAlign: "left", color: "#E8C67A" }}>FREE DOWNLOAD</div>
        <h2 style={{ textAlign: "left" }}>Get the Scam Checklist</h2>
        <p>A one-page checklist to run before you wire any money to a new supplier.</p>
      </div>
      <div className="reqcard">
        {done ? <p style={{ color: "var(--navy)", fontWeight: 700 }}>✓ Sent — check your email.</p> : (
          <form onSubmit={submit}>
            <input placeholder="Your name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} style={bi} data-testid="scam-name" />
            <input placeholder="Email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} style={bi} data-testid="scam-email" />
            <input placeholder="WhatsApp (optional)" value={f.whatsapp} onChange={(e) => setF({ ...f, whatsapp: e.target.value })} style={bi} />
            <button className="btn btn-red" style={{ width: "100%" }} data-testid="scam-submit">Send me the checklist</button>
          </form>
        )}
      </div>
    </div>
  );
}
const bi = { width: "100%", border: "1.5px solid var(--line)", borderRadius: 10, padding: "11px 12px", fontSize: 14, marginBottom: 10, fontFamily: "inherit" };

export default function Risks() {
  const content = useContent();
  const list = content.risks?.length ? content.risks : RISKS;
  const faqs = list.map(([, title, body]) => ({ q: title, a: body }));
  return (
    <SiteLayout>
      <ProgressBar />
      <Seo
        title="Costly Sourcing Mistakes & How to Avoid Them | The Sourcing Atlas"
        description="The 12 costliest mistakes importers make sourcing from China, India, Vietnam and Thailand — and the exact checks that prevent lost deposits, quality failures and fraud."
        path="/risks"
        ogImage={ogUrl("Costly Sourcing Mistakes & How to Avoid Them", "Buyer Guide")}
        jsonLd={[breadcrumbLd([{ name: "Home", path: "/" }, { name: "Guides", path: "/guides" }, { name: "Risks", path: "/risks" }]), faqLd(faqs)]}
      />
      <div className="crumb"><Link to="/">Home</Link> › <Link to="/guides">Guides</Link> › Risks</div>
      <div className="pband">
        <div className="pband-in">
          <span className="tierpill tn">AVOID THESE</span>
          <h1>Costly sourcing mistakes and how to avoid them</h1>
          <p className="lede">The mistakes that cost importers the most money — and the specific step that prevents each one.</p>
        </div>
      </div>
      <section>
        <div className="wrap" style={{ maxWidth: 860 }}>
          <p className="sub2" style={{ textAlign: "left" }}>
            Most sourcing losses are not bad luck — they are the same handful of avoidable mistakes,
            repeated. Here is our honest field list, with the check that prevents each one.
          </p>
          <div className="risklist">
            {list.map(([id, title, body, conseq], i) => (
              <React.Fragment key={id}>
                <RiskCard id={id} title={`${i + 1}. ${title}`} body={body} consequence={conseq} />
                {(i === 3 || i === 8) && <ScamBand />}
              </React.Fragment>
            ))}
          </div>
        </div>
      </section>
      <RelatedStrip items={[
        { kicker: "Guide", title: "The China Sourcing Atlas", to: "/guides/china-sourcing-atlas" },
        { kicker: "Guide", title: "First Container Playbook", to: "/guides" },
        { kicker: "Service", title: "Verification & Inspection", to: "/services" },
      ]} />
    </SiteLayout>
  );
}
